import React, { useState } from "react";
import styles from "./SchoolCalendar.module.css";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import Dropdown from "../../components/Dropdown/Dropdown";
import IconAndName from "../../components/IconAndName/IconAndName";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { IoAddCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import SearchBar from "../../components/SearchBar/SearchBar";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import CopyRight from "../../components/CopyRight/CopyRight";
import { useNavigate } from "react-router-dom";
import { FaUpload } from "react-icons/fa";

const SchoolCalendar = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedActions, setSelectedActions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleBulkUpload = () => {
    dispatch(openModal("bulkUploadStudent"));
  };
  const [selectedMonth, setSelectedMonth] = useState(6); // July (0-indexed)
  const [selectedYear, setSelectedYear] = useState(2025);

  // Example Holiday Dates
  const holidays = ["2025-07-07", "2025-07-14"];



  const navigate = useNavigate();
  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const events = [
    { date: "2025-07-08", label: "Holiday" },
    { date: "2025-07-15", label: "Sports Day" },
    { date: "2025-07-22", label: "Annual Day" },
  ];
  
  const buildCalendarData = (year, month) => {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDayIndex = (firstDay.getDay() + 6) % 7; // Monday = 0

    const weeks = [];
    let currentWeek = Array(startDayIndex).fill(null);

    for (let date = 1; date <= lastDay.getDate(); date++) {
      const fullDate = new Date(year, month, date);
      const dateStr = fullDate.toISOString().split("T")[0];

      const event = events.find((e) => e.date === dateStr);

      currentWeek.push({
        day: date,
        label: event ? event.label : "No Event",
        isSpecial: !!event, // ← true if it's an event or holiday
      });

      if (currentWeek.length === 7) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
    }

    if (currentWeek.length) {
      while (currentWeek.length < 7) currentWeek.push(null);
      weeks.push(currentWeek);
    }

    return weeks;
  };
  
  

  const calendarData = buildCalendarData(selectedYear, selectedMonth);
  const getColumnData = (rows) => {
    return rows.map((week) => {
      const row = {};
      week.forEach((dayObj, idx) => {
        row[`day${idx}`] = dayObj ? (
          <div className={styles.cellWrapper}>
            <div className={styles.dayLabel}>{dayObj.day}</div>
            <div
              className={
                dayObj.isSpecial
                  ? styles.holidayBox // Use one shared style for all special days
                  : styles.noEventBox
              }
            >
              {dayObj.label}
            </div>
          </div>
        ) : (
          <div></div>
        );
      });
      return row;
    });
  };
  
  

  const displayData = getColumnData(calendarData);

  

  const headingsData = weekDays.map((day, i) => ({
    title: (
      <div>
        <div className={styles.weekDay}>{day}</div>
      </div>
    ),
    accessor: `day${i}`,
  }));
  

  const handleArchiveClick = () => {
    navigate("/view-archived");
  };
  const handleAddClick = () => dispatch(openModal("addEvent"));

  return (
    <div className={styles.copyright}>
      <div className={styles.screen}>
        <div className={styles.contentWrapper}>
          <div className={styles.toolbarWrapper}>
            <IconAndName
              icon={<IoAddCircleOutline size={16} />}
              title="Create"
              onClick={handleAddClick}
              bgColor="Primary_Color"
            />
            <IconAndName
              icon={<FaUpload />}
              title="Bulk Upload"
              bgColor="Primary_Color"
              onClick={handleBulkUpload}
            />
          </div>

          <div className={styles.totaldatacard}>
            <div className={styles.barsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search by event name"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.fourfilters}>
                <div className={styles.monthYearWrapper}>
                  <select
                    className={styles.monthDropdown}
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(Number(e.target.value))}
                  >
                    {Array.from({ length: 12 }, (_, i) => (
                      <option key={i} value={i}>
                        {new Date(0, i).toLocaleString("default", {
                          month: "long",
                        })}
                      </option>
                    ))}
                  </select>

                  <select
                    className={styles.yearDropdown}
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                  >
                    {[2024, 2025, 2026].map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>

                <Dropdown
                  label="Upcoming"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedStaff}
                />
                <Dropdown
                  label="All Rooms"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedActions}
                />
                <Dropdown
                  label="All Categories"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedActions}
                />
              </div>
            </div>
  

            <div>
              <div className={styles.dynamicdata}>
                <DynamicTable
                  headings={headingsData}
                  columnData={displayData.slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )}
                />
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
};

export default SchoolCalendar;
